import React from 'react';
import { Tooltip } from 'antd';

import ExhibitCategoryEditableTable from '../../ExhibitCategoryEditableTable';
import { CATEGORY_TYPE } from '../../../../../constants/service/app/categoryConstants';
import ExhibitCategoryTable from '../../ExhibitCategoryTable';
import CategoryListTabBox from '../../common/CategoryListTabBox';

const ExhibitCategory = (props) => {
  const {
    onDelete,
    onDragEnd,
    isEditable,
    selectedExhibitMainCategoryList,
    selectedExhibitSubCategoryList,
    exhibitCategoryTabType,
    exhibitEmphasisCategoryDataSource,
    onSelectExhibit,
    onSelectAllExhibit,
    setExhibitCategoryTabType,
    exhibitGeneralCategoryDataSource,
  } = props;

  return (
    <CategoryListTabBox
      className={isEditable ? 'exhibit-category-editable-list-wrap' : 'exhibit-category-list-wrap'}
      title={
        <>
          <div className="main-title">전시 카테고리</div>
          <Tooltip
            title={
              <>
                <div>사용자 화면에 전시 되고 있는</div>
                <div>카테고리 노출 순서를 확인 할 수 있는 영역입니다.</div>
              </>
            }
            trigger="click"
          >
            <button className="category-exposure-type-caution-btn">!</button>
          </Tooltip>
        </>
      }
      categoryTabType={exhibitCategoryTabType}
      setCategoryTabType={setExhibitCategoryTabType}
    >
      {isEditable ? (
        <ExhibitCategoryEditableTable
          exhibitCategoryDataSource={
            exhibitCategoryTabType === String(CATEGORY_TYPE.GENERAL)
              ? exhibitGeneralCategoryDataSource
              : exhibitEmphasisCategoryDataSource
          }
          onDelete={onDelete}
          onDragEnd={onDragEnd}
          onSelectExhibit={onSelectExhibit}
          onSelectAllExhibit={onSelectAllExhibit}
          exhibitCategoryTabType={exhibitCategoryTabType}
          selectedExhibitCategoryList={[...selectedExhibitMainCategoryList, ...selectedExhibitSubCategoryList]}
        />
      ) : (
        <ExhibitCategoryTable
          exhibitCategoryDataSource={
            exhibitCategoryTabType === String(CATEGORY_TYPE.GENERAL)
              ? exhibitGeneralCategoryDataSource
              : exhibitEmphasisCategoryDataSource
          }
        />
      )}
    </CategoryListTabBox>
  );
};

export default ExhibitCategory;
